const validation = {
	boolean_required_true: {
		invalid: "This checkbox is required.",
	},
	coc: {
		invalid: "Enter a valid Chamber of Commerce number.",
		same_as_tuxis: "The Chamber of Commerce number is the same as Tuxis .",
	},
	dadup: {
		invalid_bucket_name: "Only letters and numbers are permitted.",
		invalid_display_name:
			"Only letters, numbers, spaces, and the characters '-_' are permitted. However, the name may not begin with a '-' or '_'",
	},
	datastore_name: {
		invalid: "Only letters, numbers, and the characters '-_' are allowed.",
	},
	date: {
		invalid: "Enter a valid date.",
	},
	date_of_birth: {
		invalid: "The entered date of birth must be at least 6 years ago.",
	},
	dns: {
		invalid: "The input does not match a valid DNS format.",
	},
	email: {
		invalid: "Enter a valid email address.",
	},
	errors: {
		ssh_key_invalid: "The SSH key has an invalid type or description",
		unknown: "Something went wrong... if the problem persists, we recommend contacting us.",
	},
	house_number: {
		invalid: "Enter a valid house number. The house number can only contain digits.",
	},
	input_free_text: {
		invalid: "Only letters, numbers, spaces, and the characters '.-+@!#$%^&*()=' are allowed.",
		max_length: "Use a maximum of {{length}} characters.",
		min_length: "Use at least {{length}} characters.",
	},
	input_number: {
		max_length: "The number cannot be higher than {{length}}.",
		min_length: "The number cannot be lower than {{length}}.",
		only_numbers: "You can only use numbers.",
	},
	input_select: {
		invalid: "Select a valid value",
	},
	input_text: {
		invalid: "Only letters, numbers, spaces, and the characters '.-' are allowed.",
		max_length: "Use a maximum of {{length}} characters.",
		min_length: "Use at least {{length}} characters.",
	},
	name: {
		invalid:
			"The name entered contains characters that are not allowed. Use only letters, spaces and the characters , . - '",
	},
	otp: {
		invalid: "Your 2FA code is incorrect or expired! Please try again with a new code.",
		only_numbers: "Your 2FA code can only consist of numbers.",
	},
	oxxa_company_name: {
		invalid:
			"The company name entered does not meet our third party requirements. The company name may only consist of letters, numbers, spaces and the characters &-().'",
	},
	password: {
		invalid: "Your password is incorrect!",
		invalid_current: "Your current password is incorrect!",
		no_change: "Your new password and your current password are the same.",
		no_match: "Confirmation password doesn't match the password.",
		to_weak: "Password does not meet our requirements",
		tooltip: "Use at least 12 characters (lowercase, uppercase, numbers, and special characters).",
	},
	phone: {
		invalid: "Enter a valid phone number. Allowed are digits, spaces and the character -",
		too_few_phone_number_digits:
			"A minimum of {{length}} digits must be entered in the phone number field.",
		too_many_phone_number_digits:
			"Up to {{length}} digits can be entered in the phone number field.",
	},
	product_number_hostfact_invalid: {
		invalid:
			"Hostfact number does not meet the format. The number must begin with a P followed by 3 to 6 digits (P000 or P000000)",
	},
	proxmox_fingerprint: {
		invalid: "Invalid fingerprint: does not match Proxmox regex.",
	},
	proxmox_host: {
		invalid: "Invalid hostname: does not match Proxmox regex.",
	},
	proxmox_regex: {
		invalid: "Field input does not match Proxmox regex.",
	},
	proxmox_regex_free: {
		invalid: "Field input does not match Proxmox regex.",
	},
	proxmox_token_name: {
		invalid: "Invalid token name: does not match Proxmox regex.",
	},
	proxmox_user_name: {
		invalid: "Invalid username: does not match Proxmox regex.",
	},
	required: "Input field required!",
	snapshot: {
		invalid:
			'The name of your snapshot does not match the correct format. Use letters, numbers, and/or hyphens. Do not use spaces. The word "portal" is not allowed.',
	},
	ssh_public_key: {
		invalid: "Your SSH key format is incorrect. Only OpenSSH standard formats are supported.",
	},
	username: {
		exist: "This username is already taken!",
		invalid:
			"Username does not meet the requirements! Use letters, numbers, hyphens, and/or at signs.",
	},
	vat_number: {
		invalid: "Enter a valid VAT identification number.",
		same_as_tuxis: "The VAT identification number cannot be the same as Tuxis.",
	},
	zip_code: {
		invalid: "Enter a valid zip code.",
	},
};

export default validation;
